// this is a main config we use to generate emoji DICT

import {ItemIcon} from "./@type";

export const ItemIconConfig : ItemIcon[] = [
    // AI agent icons — exposed only via AI_AGENT_ICON_CATEGORIES (not in task/project pickers).
    {name: 'ai-default', className: 'i5-default-ai', keyword: 'ai default agent'},
    {name: 'ai-brain',   className: 'i5-brain-ai',   keyword: 'ai brain'},
    {name: 'ai-code',    className: 'i5-code-ai',    keyword: 'ai code dev'},
    {name: 'ai-compass', className: 'i5-compass-ai', keyword: 'ai compass guide'},
    {name: 'ai-gear',    className: 'i5-gear-ai',    keyword: 'ai gear settings'},
    {name: 'ai-rocket',  className: 'i5-rocket-ai',  keyword: 'ai rocket launch'},
    {name: 'ai-support', className: 'i5-support-ai', keyword: 'ai support help'},
    {name: 'ai-write',   className: 'i5-write-ai',   keyword: 'ai write text'},

    {
        name        : 'todo-list',
        className   : 'i5-todo-list',
    },
    {
        name        : 'whiteboard',
        className   : 'i5-whiteboard',
    },
    {
        name        : 'workspace',
        className   : 'i5-departments'
    },
    {
        name        : 'tasks',
        className   : 'i5-tasks'
    },
    {
        name        : 'task',
        className   : 'ii5-task'
    },
    {
        name        : 'idea',
        className   : 'ii5-idea'
    },
    {
        name        : 'question',
        className   : 'ii5-question'
    },
    {
        name        : 'bug',
        className   : 'ii5-bug'
    },
    {
        name        : 'beer',
        className   : 'ii5-beer'
    },
    {
        name        : 'book',
        className   : 'ii5-book'
    },
    {
        name        : 'briefcase',
        className   : 'ii5-briefcase'
    },
    {
        name        : 'social_broadcast',
        className   : 'ii5-broadcast'
    },
    {
        name        : 'upload',
        className   : 'ii5-cloud-upload'
    },
    {
        name        : 'download',
        className   : 'ii5-cloud-download'
    },
    {
        name        : 'device_mobile',
        className   : 'ii5-device-mobile'
    },
    {
        name        : 'device_desktop',
        className   : 'ii5-device-desktop'
    },
    {
        name        : 'phone',
        className   : 'ii5-phone'
    },
    {
        name        : 'money',
        className   : 'ii5-money'
    },
    {
        name        : 'device_video',
        className   : 'ii5-device-camera-video'
    },
    {
        name        : 'device_camera',
        className   : 'ii5-device-camera'
    },
    {
        name        : 'database',
        className   : 'ii5-database'
    },
    {
        name        : 'file_binary',
        className   : 'ii5-file-binary'
    },
    {
        name        : 'file_code',
        className   : 'ii5-file-code'
    },
    {
        name        : 'file_contact',
        className   : 'ii5-file-contact'
    },
    {
        name        : 'file_text',
        className   : 'ii5-file-text'
    },
    {
        name        : 'flame',
        className   : 'ii5-flame'
    },
    {
        name        : 'globe',
        className   : 'ii5-globe'
    },
    {
        name        : 'gift',
        className   : 'ii5-gift'
    },
    {
        name        : 'dev_gist',
        className   : 'ii5-project-dev'
    },
    {
        name        : 'graph',
        className   : 'ii5-graph'
    },
    {
        name        : 'law',
        className   : 'ii5-law'
    },
    {
        name        : 'key',
        className   : 'ii5-key'
    },
    {
        name        : 'location',
        className   : 'ii5-location'
    },
    {
        name        : 'mail',
        className   : 'ii5-mail-black'
    },
    {
        name        : 'mail_read',
        className   : 'ii5-mail-read'
    },
    {
        name        : 'mention',
        className   : 'ii5-mention'
    },
    {
        name        : 'milestone',
        className   : 'ii5-milestone'
    },
    {
        name        : 'study',
        className   : 'ii5-graduation'
    },
    {
        name        : 'pulse',
        className   : 'ii5-pulse'
    },
    {
        name        : 'social_rss',
        className   : 'ii5-rss'
    },
    {
        name        : 'search',
        className   : 'ii5-search'
    },
    {
        name        : 'squirrel',
        className   : 'ii5-squirrel'
    },
    {
        name        : 'steps',
        className   : 'ii5-steps'
    },
    {
        name        : 'telescope',
        className   : 'ii5-telescope'
    },
    {
        name        : 'tools',
        className   : 'ii5-tools'
    },
    {
        name        : 'contact',
        className   : 'ii5-contact'
    },
    {
        name        : 'anchor',
        className   : 'ii5-anchor'
    },
    {
        name        : 'bookmark',
        className   : 'ii5-bookmark'
    },
    {
        name        : 'burst',
        className   : 'ii5-burst'
    },
    {
        name        : 'first_aid',
        className   : 'ii5-first-aid'
    },
    {
        name        : 'paint_bucket',
        className   : 'ii5-paint-bucket'
    },
    {
        name        : 'quote',
        className   : 'ii5-quote'
    },
    {
        name        : 'social_youtube',
        className   : 'ii5-social-youtube'
    },
    {
        name        : 'trophy',
        className   : 'ii5-trophy',
        keyword     : 'goal trophy win'
    },
    {
        name        : 'shield',
        className   : 'ii5-shield'
    },
    {
        name        : 'shopping_cart',
        className   : 'ii5-shopping-cart'
    },
    {
        name        : 'rocket',
        className   : 'ii5-rocket'
    },
    {
        name        : 'brush',
        className   : 'ii5-brush'
    },
    {
        name        : 'bucket',
        className   : 'ii5-bucket'
    },
    {
        name        : 'social_twitter',
        className   : 'ii5-social-twitter'
    },
    {
        name        : 'userSearch',
        className   : 'ii5-user-search'
    },
    {
        name        : 'megaphone',
        className   : 'ii5-megaphone'
    },
    {
        name        : 'tshirt',
        className   : 'ii5-tshirt'
    },
    {
        name        : 'wheelchair',
        className   : 'ii5-wheelchair'
    },
    {
        name        : 'server',
        className   : 'ii5-server'
    },
    {
        name        : 'microchip',
        className   : 'ii5-microchip'
    },
    {
        name        : 'lightning',
        className   : 'ii5-lightning'
    },
    {
        name        : 'network',
        className   : 'ii5-chart-network'
    },
    {
        name        : 'resources',
        className   : 'ii5-resource-planning'
    },
    {
        name        : 'file_audio',
        className   : 'ii5-file-audio'
    },
    {
        name        : 'file_media',
        className   : 'ii5-file-media'
    },
    {
        name        : 'file_video',
        className   : 'ii5-file-video'
    },
    {
        name        : 'file_archive',
        className   : 'ii5-file-archive'
    },
    {
        name        : 'spreadsheet',
        className   : 'ii5-file-spreadsheet'
    },
    {
        name        : 'credit_card',
        className   : 'ii5-credit-card'
    },
    {
        name        : 'suitcase',
        className   : 'ii5-suitcase-rolling'
    },
    {
        name        : 'graduate',
        className   : 'ii5-mortar-board'
    },
    {
        name        : 'pencil',
        className   : 'ii5-pencil-alt'
    },
    {
        name        : 'paint_roller',
        className   : 'ii5-paint-roller'
    },
    {
        name        : 'chess',
        className   : 'ii5-game-board'
    },
    {
        name        : 'game_console',
        className   : 'ii5-game-console-handheld'
    },
    {
        name        : 'music',
        className   : 'ii5-music'
    },
    {
        name        : 'speaker',
        className   : 'ii5-speaker'
    },
    {
        name        : 'microphone',
        className   : 'ii5-microphone'
    },
    {
        name        : 'football_ball',
        className   : 'ii5-football-ball'
    },
    {
        name        : 'flask',
        className   : 'ii5-flask-potion'
    },
    {
        name        : 'birthday_cake',
        className   : 'ii5-birthday-cake'
    },
    {
        name        : 'hotel',
        className   : 'ii5-hotel'
    },
    {
        name        : 'flag',
        className   : 'ii5-bottleneck'
    },
    {
        name        : 'geo',
        className   : 'ii5-geo'
    },
    {
        name        : 'watch',
        className   : 'ii5-watch'
    },
    {
        name        : 'feather',
        className   : 'ii5-feather-alt'
    },
    {
        name        : 'magic_wand',
        className   : 'ii5-actions'
    },
    {
        name        : 'smile',
        className   : 'ii5-smile'
    },
    {
        name        : 'smile_sad',
        className   : 'ii5-smile-sad'
    },
    {
        name        : 'zzz',
        className   : 'ii5-zzz'
    },
    {
        name        : 'life_ring',
        className   : 'ii5-life-ring'
    },
    {
        name        : 'tachometer',
        className   : 'ii5-tachometer-alt-average'
    },
    {
        name        : 'folder',
        className   : 'ii5-folder'
    },
    {
        name        : 'open_folder',
        className   : 'ii5-folder'
    },
    {
        name        : 'project',
        className   : 'ii5-project'
    },
    {
        name        : 'page',
        className   : 'ii5-task-list'
    },
    {
        name        : 'dev',
        className   : 'ii5-project-dev'
    },
    {
        name        : 'sprint',
        className   : 'ii5-sprint'
    },
    {
        name        : 'backlog',
        className   : 'ii5-someday-3'
    },
    {
        name        : 'someday_3',
        className   : 'ii5-someday-3'
    },
    {
        name        : 'tag',
        className   : 'ii5-tag'
    },
    {
        name        : 'kanban',
        className   : 'ii5-kanban'
    },
    {
        name        : 'scrum',
        className   : 'ii5-agile'
    },
    {
        name        : 'files',
        className   : 'ii5-documents'
    },
    {
        name        : 'report',
        className   : 'i5-chart-bar'
    },
    {
        name        : 'mobile',
        className   : 'ii5-device-mobile'
    },
    {
        name        : 'desktop',
        className   : 'ii5-device-desktop'
    },
    {
        name        : 'support',
        className   : 'ii5-support'
    },
    {
        name        : 'requests',
        className   : 'ii5-archive',
        keyword     : 'request chat message'
    },
    {
        name        : 'archive',
        className   : 'ii5-archive'
    },
    {
        name        : 'api',
        className   : 'ii5-api'
    },
    {
        name        : 'qa',
        className   : 'ii5-qa'
    },
    {
        name        : 'paint',
        className   : 'ii5-paint-bucket'
    },
    {
        name        : 'leads',
        className   : 'ii5-leads'
    },
    {
        name        : 'calendar',
        className   : 'ii5-calendar'
    },
    {
        name        : 'cloud',
        className   : 'ii5-cloud'
    },
    {
        name        : 'home',
        className   : 'ii5-home'
    },
    {
        name        : 'mail_black',
        className   : 'ii5-mail-black'
    },
    {
        name        : 'projection_screen',
        className   : 'ii5-projection-screen'
    },
    {
        name        : 'android',
        className   : 'ii5-social-android'
    },
    {
        name        : 'social_android',
        className   : 'ii5-social-android'
    },
    {
        name        : 'apple',
        className   : 'ii5-social-apple'
    },
    {
        name        : 'social_apple',
        className   : 'ii5-social-apple'
    },
    {
        name        : 'windows',
        className   : 'ii5-social-windows'
    },
    {
        name        : 'social_windows',
        className   : 'ii5-social-windows'
    },
    {
        name        : 'education',
        className   : 'ii5-graduation'
    },
    {
        name        : 'graduation_cap',
        className   : 'ii5-graduation'
    },
    {
        name        : 'assets',
        className   : 'ii5-assets'
    },
    {
        name        : 'event',
        className   : 'ii5-event'
    },
    {
        name        : 'img',
        className   : 'ii5-image'
    },
    {
        name        : 'inventory',
        className   : 'ii5-inventory'
    },
    {
        name        : 'target',
        className   : 'ii5-target'
    },
    {
        name        : 'taskList',
        className   : 'ii5-task-list'
    },
    {
        name        : 'aim',
        className   : 'ii5-aim'
    },
    {
        name        : 'request',
        className   : 'ii5-request',
        keyword     : 'request chat message'
    },
    {
        name        : 'request2',
        className   : 'ii5-request2'
    },
    {
        name        : 'twitter',
        className   : 'ii5-social-twitter'
    },
    {
        name        : 'wiki',
        className   : 'ii5-wiki'
    },
    {
        name        : 'information',
        className   : 'ii5-information'
    },
    {
        name        : 'brand',
        className   : 'ii5-brand'
    },
    {
        name        : 'graduation',
        className   : 'ii5-graduation'
    },
    {
        name        : 'image',
        className   : 'ii5-image'
    },
    {
        name        : 'group',
        className   : 'i5-group'
    },
    {
        name        : 'section',
        className   : 'i5-section',
        keyword     : 'section menu block'
    },
    {
        name        : 'link',
        className   : 'i5-copy-link'
    },
    {
        name        : 'embed',
        className   : 'i5-embeded-code'
    },
    {
        name        : 'facebook',
        className   : 'i5-facebook'
    },
    {
        name        : 'figma',
        className   : 'i5-figma'
    },
    {
        name        : 'googleCalendar',
        className   : 'i5-google-cal'
    },
    {
        name        : 'googleDoc',
        className   : 'i5-google-doc'
    },
    {
        name        : 'googleMap',
        className   : 'i5-google-maps'
    },
    {
        name        : 'googleSheet',
        className   : 'i5-google-sheet'
    },
    {
        name        : 'googleSlides',
        className   : 'i5-google-slides'
    },
    {
        name        : 'twitterX',
        className   : 'i5-twitter'
    },
    {
        name        : 'youtube',
        className   : 'i5-youtube'
    },
    {
        name        : 'view',
        className   : 'i5-view'
    },
    {
        name        : 'view-list',
        className   : 'i5-tasks'
    },
    {
        name        : 'view-table',
        className   : 'i5-table'
    },
    {
        name        : 'view-board',
        className   : 'i5-board'
    },
    {
        name        : 'view-calendar',
        className   : 'i5-calendar'
    },
    {
        name        : 'view-events-summary',
        className   : 'i5-events-summary'
    },
    {
        name        : 'view-expenses',
        className   : 'i5-expenses-light'
    },
    {
        name        : 'view-gantt',
        className   : 'i5-gantchart2'
    },
    {
        name        : 'view-workload',
        className   : 'i5-timeline'
    },
    {
        name        : 'view-timeline',
        className   : 'i5-timeline-2'
    },
    {
        name        : 'view-activity',
        className   : 'i5-activity'
    },
    {
        name        : 'view-what-is-done',
        className   : 'i5-whats-done'
    },
    {
        name        : 'view-pastdue',
        className   : 'i5-pastdue'
    },
    {
        name        : 'view-priorities',
        className   : 'i5-priority'
    },
    {
        name        : 'view-action-required',
        className   : 'i5-user-action-required'
    },
    {
        name        : 'view-tasks-by-user',
        className   : 'i5-task-by-user'
    },
    {
        name        : 'view-portfolio',
        className   : 'ii5-assets'
    },
    {
        name        : 'view-projects-list',
        className   : 'i5-projects-list'
    },
    {
        name        : 'view-dashboard',
        className   : 'i5-dashboard'
    },


    {
        name        : 'goals',
        className   : 'i5-goals'
    },
    {
        name        : 'meetings',
        className   : 'i5-meeting'
    },
    {
        name        : 'expenses',
        className   : 'i5-expenses-light'
    },
    {
        name        : 'discussions',
        className   : 'i5-discussion-light'
    },
    {
        name        : 'board',
        className   : 'i5-board'
    },



    {
        name        : 'user-card',
        className   : 'i5-crm-contact',
        keyword     : 'user contact crm'
    },
    {
        name        : 'offices',
        className   : 'i5-crm-account',
        keyword     : 'account crm office building house office'
    },


    {
        name        : 'user',
        className   : 'i5-user',
        keyword     : 'user'
    },

    {
        name        : 'users',
        className   : 'i5-users',
        keyword     : 'users team'
    },

   ////////

    {
        name: "numbers",
        className: "i5-numbers"
    },
    {
        name: "percent",
        className: "i5-percent"
    },
    {
        name: "task",
        className: "ii5-task"
    },
    {
        name: "question",
        className: "ii5-question"
    },
    {
        name: "broadcast",
        className: "ii5-broadcast"
    },
    {
        name: "cloud-upload",
        className: "ii5-cloud-upload"
    },
    {
        name: "cloud-download",
        className: "ii5-cloud-download"
    },
    {
        name: "device-mobile",
        className: "ii5-device-mobile"
    },
    {
        name: "device-desktop",
        className: "ii5-device-desktop"
    },
    {
        name: "phone",
        className: "ii5-phone"
    },
    {
        name: "device-camera-video",
        className: "ii5-device-camera-video"
    },
    {
        name: "file-binary",
        className: "ii5-file-binary"
    },
    {
        name: "file-code",
        className: "ii5-file-code"
    },
    {
        name: "file-contact",
        className: "ii5-file-contact"
    },
    {
        name: "file-text",
        className: "ii5-file-text"
    },
    {
        name: "gift",
        className: "ii5-gift"
    },
    {
        name: "project-dev",
        className: "ii5-project-dev"
    },
    {
        name: "copy-link",
        className: "i5-copy-link"
    },
    {
        name: "location",
        className: "ii5-location"
    },
    {
        name: "mail-black",
        className: "ii5-mail-black"
    },
    {
        name: "mail-read",
        className: "ii5-mail-read"
    },
    {
        name: "graduation",
        className: "ii5-graduation"
    },
    {
        name: "pulse",
        className: "ii5-pulse"
    },
    {
        name: "rss",
        className: "ii5-rss"
    },
    {
        name: "steps",
        className: "ii5-steps"
    },
    {
        name: "first-aid",
        className: "ii5-first-aid"
    },
    {
        name: "paint-bucket",
        className: "ii5-paint-bucket"
    },
    {
        name: "social-youtube",
        className: "ii5-social-youtube"
    },
    {
        name: "shield",
        className: "ii5-shield"
    },
    {
        name: "shopping-cart",
        className: "ii5-shopping-cart"
    },
    {
        name: "social-twitter",
        className: "ii5-social-twitter"
    },
    {
        name: "user-search",
        className: "ii5-user-search"
    },

    {
        name: "request-form",
        className: "i5-request"
    },

    {
        name: "request-form-edit",
        className: "i5-request-form"
    },


]
